import { CL009_COUNTRY_CODES_COMMON_TRANSIT } from 'shared/ncts/common/constants'
import { COUNTRY_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'

const C0001Validator = {
  validateConsignmentConsigneeRequirement: ({
    isConsignmentConsigneePresent,
    hasConsignmentAdditionalReference30600,
    hasHouseConsignmentAdditionalReference30600,
  }: {
    isConsignmentConsigneePresent?: boolean
    hasConsignmentAdditionalReference30600?: boolean
    hasHouseConsignmentAdditionalReference30600?: boolean
  }) => {
    if (hasConsignmentAdditionalReference30600) return 'NOT_ALLOWED'
    if (hasHouseConsignmentAdditionalReference30600) {
      return 'NOT_ALLOWED'
    }

    return isConsignmentConsigneePresent ? 'REQUIRED' : 'OPTIONAL'
  },
  validateConsigneeRequirementForHouseConsignment: ({
    security,
    isConsignmentConsigneePresent,
    countryOfDestination,
    houseCountryOfDestination,
    hasHouseConsignmentWithCtcDestination,
    hasItemWithCtcDestination,
    hasConsignmentAdditionalReference30600,
    hasHouseConsignmentAdditionalReference30600,
  }: {
    security: string
    isConsignmentConsigneePresent?: boolean
    countryOfDestination?: string
    houseCountryOfDestination?: string
    hasHouseConsignmentWithCtcDestination?: boolean
    hasItemWithCtcDestination?: boolean
    hasConsignmentAdditionalReference30600?: boolean
    hasHouseConsignmentAdditionalReference30600?: boolean
  }) => {
    if (isConsignmentConsigneePresent) return 'NOT_ALLOWED'

    const country = removePrefix(countryOfDestination, COUNTRY_CODE_PREFIX)
    if (country && CL009_COUNTRY_CODES_COMMON_TRANSIT.includes(country)) {
      return 'REQUIRED'
    }

    const houseDestinationCountry = removePrefix(houseCountryOfDestination, COUNTRY_CODE_PREFIX)
    if (houseDestinationCountry && CL009_COUNTRY_CODES_COMMON_TRANSIT.includes(houseDestinationCountry)) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (hasHouseConsignmentWithCtcDestination) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (hasItemWithCtcDestination) return 'REQUIRED'
    if (['0', '1'].includes(security)) return 'OPTIONAL'
    if (hasConsignmentAdditionalReference30600) return 'NOT_ALLOWED'
    if (hasHouseConsignmentAdditionalReference30600) return 'NOT_ALLOWED'

    return 'OPTIONAL'
  },
} as const

export default C0001Validator
